import V2BoardAPI from './api';

export const getNotices = async (api) => {
  return await api.call('/api/v1/user/notice/fetch');
};
